// Imports ------------------------------------------------------------------->

import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";
import * as ecomUtil from "../../utils/ecom";
import {icons} from "../../icons/Icons";

import {inject} from "../../services/di";
import {AnalyticsService} from "../../services/AnalyticsService";
import {ShoppingListService, SLEcomItem} from "../../services/ShoppingListService";
import {FlyerService} from "../../services/FlyerService";
import {EventService} from "../../services/EventService";
import {EcomService, EcomItem} from "../../services/EcomService";
import {ConfigService} from "../../services/ConfigService";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

// ClipItemButton ----------------------------------------------------------->

interface ClipEcomItemButtonAttributes extends JSX.HTMLProps {
	ecomItemId: number;
}

@element("flipp-clip-ecom-item", "button")
export class ClipEcomItemButton extends Component<ClipEcomItemButtonAttributes, EcomItem> {
	@attr ecomItemId: number;
	@inject shoppingList: ShoppingListService;
	@inject config: ConfigService;
	@inject flyerService: FlyerService;
	@inject eventService: EventService;
	@inject analytics: AnalyticsService;
	@inject ecomService: EcomService;

	onAttach() {
		this.addEventListener("click", this._handleClick);
		this.classList.add("flipp-button");
		this.classList.add("secondary");
	}

	onDetach() {
		this.removeEventListener("click", this._handleClick);
	}

	prepare() {
		return this.ecomService.getEcomItem(this.ecomItemId);
	}

	render(item: EcomItem) {
		const isClipped = this.shoppingList.localList.ecomItems
			.filter((ecomItem) => `${ecomItem.ecomItemId}` === `${item.id}`)
			.length > 0;
		return <div>
			<span class="icon">{icons.scissors}</span>
			{isClipped ? i18n("remove_clip_button") : i18n("add_clip_button")}
		</div>;
	}

	private _handleClick = (e: Event) => {
		const item = this.model;
		const ecomClipping = new SLEcomItem({
			id: `${item.id}`,
			name: item.name,
			ecom_item_id: item.id,
			price: item.currentPrice,
			merchant_name: item.merchant,
			merchant_id: item.merchantId,
			merchant_logo_url: item.merchantLogo,
			thumbnail_url: ecomUtil.thumbnail(item),
			cta_label: i18n("buy_online"), // TODO: should we be hardcoding this label?
			cta_url: item.url,
			expired: false
		});

		const match = this.shoppingList.localList.ecomItems
			.filter((ecomItem) => `${ecomItem.ecomItemId}` === `${item.id}`);
		const shouldAdd = !match || match.length === 0;
		if (shouldAdd) {
			this.shoppingList.localList.add([ecomClipping]);
		} else {
			this.shoppingList.localList.remove(match);
		}

		if (shouldAdd)
			this.analytics.trackEcomItem(item.id, item.merchantId, item.merchant, 4, false);
		this.eventService.fireClippingsChangedEvent();
		this.invalidate();
	}
}
